import React, { ComponentProps } from 'react';
import styled from 'styled-components';
import { Loader as BaseLoader } from 'component-library-and-tools';

export default styled(BaseLoader)`
  && {
    color: inherit;
  }
`;
